import { Container } from "react-bootstrap";
import styled from "styled-components";

export const BasicRulesContainer = styled.section`
  position: relative;
`;

export const MainTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 3rem;
  font-weight: 700;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
`;

export const ColumnTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const ColumnDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0;
`;

export const InfoBox = styled.div`
  background: ${(props) => props.theme.colors.white};
  border-left: 4px solid ${(props) => props.theme.colors.primary};
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const InfoBoxTitle = styled.h3`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const InfoBoxDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0;
`;

export const ImageContainer = styled.div`
  text-align: center;
  margin: 2rem 0;
`;

export const RulesImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

export const ImageContainerWrapper = styled(Container)`
  background-color: ${(props) => props.theme.colors.primary};
`;
